import React from 'react'
import { Modal } from '@scuf/common'
import { ModalWrap, ModalTitle } from './device-usage-net-modal.styles'
import AssetManagementTable from '../../../../AssetManagementTable'
import PropTypes from 'prop-types'

export const columns = [
  { field: 'appName', translation: 'AssetManagementTable_appName', render: ({ value }) => <p>{value}</p>, initialWidth:'22%' },
  { field: 'pkgName', translation: 'AssetManagementTable_appPackageName', render:({ value }) => <p>{value}</p>, initialWidth:'30%' },
  { field: 'netIn', translation: 'AssetManagementTable_netIn', render: ({ value }) => <p>{value}</p> },
  { field: 'netOut', translation: 'AssetManagementTable_netOut', render: ({ value }) => <p>{value}</p> }
]

const DeviceUsageNetModal = ({ data, closeModal, t }) => {
  return (
    <ModalWrap>
      <ModalTitle>{t('NetChart_Title')}</ModalTitle>
      <Modal.Content>
        <AssetManagementTable
          columns={columns}
          data={data}
          disableRowClick={true}
          fileName='Application Usage Time'
          selectionMode='none'
        />
      </Modal.Content>
    </ModalWrap>
  )
}
DeviceUsageNetModal.defaultProps = {
  closeModal: () => null,
  data: []
}

DeviceUsageNetModal.propTypes = {
  closeModal: PropTypes.func,
  data: PropTypes.array,
  t: PropTypes.func
}

export default DeviceUsageNetModal
